import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../login/AuthContext";

const Sidebar = () => {
    const my_id = sessionStorage.getItem("my_id");;
    const location = useLocation();
    const myLogo = sessionStorage.getItem("image");
    const defaultMenus = {
        isOpen: false,
        sales: false,
        products: false,
        category: false,
        purchases: false,
        settings: false,
        privacy: false,
        payments: false,
        locations: false
    }
    const [subMenuOpen, setSubMenuOpen] = useState(defaultMenus);

    const hideShowMenu = (menuName) => {
        let oldMenu = {
            isOpen: false,
            sales: false,
            products: false,
            category: false,
            purchases: false,
            settings: false,
            privacy: false,
            payments: false,
            locations: false
        }
        oldMenu[menuName] = !subMenuOpen[menuName];
        oldMenu.isOpen = oldMenu[menuName];
        setSubMenuOpen(oldMenu)
    }

    return (
        <>
            <div className="menu">
                <div className="main-menu">
                    <div className="scroll">
                        {my_id && <ul className="list-unstyled">
                            {my_id == 100 ? <>
                                <li className={location.pathname.includes("/users") ? "active" : ""}>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/users" style={{ height: 70 }}>
                                        <i className="iconsminds-business-mens"></i><span>Users</span>
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/category") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('category')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-posterous"></i> Category
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/size") ? "active" : ""}>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/size" style={{ height: 90 }}>
                                        <i className="iconsminds-puzzle"></i><span>Size</span>
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/series") ? "active" : ""}>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/series" style={{ height: 90 }}>
                                        <i className="iconsminds-palette"></i><span>Series</span>
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/privacy") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('privacy')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-gear"></i> Privacy
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/settings") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('settings')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-gear"></i> Settings
                                    </Link>
                                </li>
                            </> : <>
                                <li className={location.pathname.includes("/dashboard") ? "active" : ""}>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/dashboard" style={{ height: 90 }}>
                                        <i className="iconsminds-dashboard"></i><span>Dashboard</span>
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/customers") ? "active" : ""}>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/customers" style={{ height: 90 }}>
                                        <i className="iconsminds-business-mens"></i><span>Customers</span>
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/sales") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('sales')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-digital-drawing"></i> Sales
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/purchase") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('purchases')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-data-storage"></i> Purchase
                                    </Link>
                                </li>

                                <li className={location.pathname.includes("/products") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('products')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-shop"></i> Products
                                    </Link>
                                </li>
                                <li className={location.pathname.includes("/settings") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('settings')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-gear"></i> Settings
                                    </Link>
                                </li>
                                {/* <li className={location.pathname.includes("/payments") ? "active" : ""}>
                                    <Link to="/payments" style={{ height: 90 }}>
                                        <i className="iconsminds-money-bag"></i><span>Payments</span>
                                    </Link>
                                </li> */}
                                <li className={location.pathname.includes("/payments") ? "active" : ""}>
                                    <Link onClick={() => hideShowMenu('payments')} to="#" style={{ height: 90 }}>
                                        <i className="iconsminds-money-bag"></i><span>Payments</span>
                                    </Link>
                                </li>
                            </>}
                        </ul>}
                    </div>
                </div>

                <div className="sub-menu" style={{ transform: subMenuOpen.isOpen ? 'translateX(0px)' : 'translateX(-230px)' }}>
                    <div className="scroll">
                        {subMenuOpen.category && <ul className="list-unstyled d-block">
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/category">
                                    <span className="d-inline-block">Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/category/add">
                                    <span className="d-inline-block">Add Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/subcategory">
                                    <span className="d-inline-block">Sub Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/subcategory/add">
                                    <span className="d-inline-block">Add Sub Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/vehicles-category">
                                    <span className="d-inline-block">Vehicles Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/vehicles-category/add">
                                    <span className="d-inline-block">Add Vehicles Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/worker-category">
                                    <span className="d-inline-block">Workers Category</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/worker-category/add">
                                    <span className="d-inline-block">Add Workers Category</span>
                                </Link>
                            </li>
                        </ul>}
                        {subMenuOpen.products && <ul className="list-unstyled d-block">
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product">
                                    <span className="d-inline-block">Products</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/add">
                                    <span className="d-inline-block">Add Product</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/add-image">
                                    <span className="d-inline-block">Add Product Image</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/sub-product">
                                    <span className="d-inline-block">Sub Product</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/sub-product/add">
                                    <span className="d-inline-block">Add Sub Product</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/view-stock">
                                    <span className="d-inline-block">View Stock</span>
                                </Link>
                            </li>
                            {/* <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/posts">
                                    <span className="d-inline-block">Post</span>
                                </Link>
                            </li> */}
                        </ul>}
                        {subMenuOpen.purchases && <ul className="list-unstyled d-block">
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase/suppliers">
                                    <span className="d-inline-block">Suppliers</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase">
                                    <span className="d-inline-block">Purchases</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase/add">
                                    <span className="d-inline-block">Add Purchase</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase-return">
                                    <span className="d-inline-block">Purchase Return</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase-order">
                                    <span className="d-inline-block">Purchase Order</span>
                                </Link>
                            </li>
                        </ul>}
                        {subMenuOpen.sales && <ul className="list-unstyled d-block">
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/party">
                                    <span className="d-inline-block">Party</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/invoices">
                                    <span className="d-inline-block">Sales Invoices</span>
                                </Link>
                            </li>
                            {/* <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/pending-orders">
                                    <span className="d-inline-block">Sales Pending Orders</span>
                                </Link>
                            </li> */}
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales-return">
                                    <span className="d-inline-block">Sales Return</span>
                                </Link>
                            </li>
                            {/* <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/cash-sales">
                                    <span className="d-inline-block">Cash Sales</span>
                                </Link>
                            </li> */}
                            {/* <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/proforma">
                                    <span className="d-inline-block">Proforma</span>
                                </Link>
                            </li> */}
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/sample-brackage">
                                    <span className="d-inline-block">Sample & Brackage</span>
                                </Link>
                            </li>

                        </ul>}
                        {subMenuOpen.settings && <ul className="list-unstyled d-block">
                            {my_id == 100 ? <>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/slider">
                                        <span className="d-inline-block">Slider</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/city">
                                        <span className="d-inline-block">City</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/state">
                                        <span className="d-inline-block">State</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/faqs">
                                        <span className="d-inline-block">Faq</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/news">
                                        <span className="d-inline-block">News</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/inquiry-settings">
                                        <span className="d-inline-block">Inquiry</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/help-line">
                                        <span className="d-inline-block">Help Line</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/testimonial">
                                        <span className="d-inline-block">Testimonial</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/app-settings">
                                        <span className="d-inline-block">App Settings</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/specification">
                                        <span className="d-inline-block">Product Specs</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/subscription">
                                        <span className="d-inline-block">Subscription</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/send-notification">
                                        <span className="d-inline-block">Send Notification</span>
                                    </Link>
                                </li>


                            </> : <>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/catalogue">
                                        <span className="d-inline-block">Catalogue Upload</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/transport">
                                        <span className="d-inline-block">Transporter</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/terms">
                                        <span className="d-inline-block">Billing Terms</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/contact-persons">
                                        <span className="d-inline-block">Contact Persons</span>
                                    </Link>
                                </li>
                                {/* <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/vehicles">
                                        <span className="d-inline-block">Vehicles</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/workers">
                                        <span className="d-inline-block">Workers</span>
                                    </Link>
                                </li> */}
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/banks">
                                        <span className="d-inline-block">Banks</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/profile">
                                        <span className="d-inline-block">Profile</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/order-permission">
                                        <span className="d-inline-block">Order Permission</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/product-permission">
                                        <span className="d-inline-block">Product Permission</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/change-password">
                                        <span className="d-inline-block">Change Password</span>
                                    </Link>
                                </li>
                            </>}
                        </ul>}
                        {subMenuOpen.privacy && <ul className="list-unstyled d-block">
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/privacy/policy-settings">
                                    <span className="d-inline-block">Privacy Policy</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/privacy/terms-settings">
                                    <span className="d-inline-block">Terms & Conditions</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/privacy/legal-settings">
                                    <span className="d-inline-block">Legal Notice</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/privacy/refund-settings">
                                    <span className="d-inline-block">Refund Policy</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/privacy/shipping-settings">
                                    <span className="d-inline-block">Shipping Policy</span>
                                </Link>
                            </li>
                        </ul>}
                        {subMenuOpen.payments && <ul className="list-unstyled d-block">
                            {/* <li>
                                <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/payments/ledger">
                                    <span className="d-inline-block">Ledger</span>
                                </Link>
                            </li> */}
                            <li>
                                 <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/payments/party-payment-ledger">
                                    <span className="d-inline-block">Party Ledger</span>
                                </Link>
                            </li>
                            <li>
                             <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/payments/add">
                                    <span className="d-inline-block">Add Payment</span>
                                </Link>
                            </li>
                        </ul>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
